import React from "react";
import {Button} from "@mui/material";

import './confirmModal.scss';
import closeIcon from '../images/close.svg';

const ConfirmModal = ({close,confirm}:any)=>{

    return <div className={'confirm-modal-wrapper'}>
        <button onClick={() => close()} className="close-btn">
            <img src={closeIcon} alt="close-modal"/>
        </button>
        <div className={'confirm-modal-title'}>Удаление реквизитов</div>
        <div className={'confirm-modal-text'}>Вы уверены, что хотите удалить реквизиты «Каспи Банк»?</div>
        <div className={'confirm-modal-action'}>
            <Button sx={{marginRight: '20px', width:'269px'}} variant="outlined" onClick={()=>close()}>Отмена</Button>
            <Button sx={{ width:'269px'}} variant="contained" onClick={()=>confirm()}>Удалить</Button>
        </div>
    </div>
}

export default ConfirmModal